export default function ErrorMessage({ error }) {
  return (
    <div className="flex items-center justify-center h-52">
      <div className="text-center">
        <h2 className="text-xl font-medium text-gray-900 mb-2">
          Something went wrong
        </h2>
        <p className="text-gray-600">{error}</p>
      </div>
    </div>
  );
}
